import React from 'react';
import { CompletionStepDefinition, SurveyDefinition } from '../../../types/Survey';
import { getTextStyles } from '../Util/surveyStyles';
import SurveyMarkdown from '../Components/SurveyMarkdown/SurveyMarkdown';
import { makeUrl } from '../../../api/makeUrl';

export interface CompletionStepProps {
    step: CompletionStepDefinition;
    surveyDefinition: SurveyDefinition;
    onBack: () => void;
}

export default function CompletionStep({
    step,
    surveyDefinition,
}: CompletionStepProps) {
    const imageUrl = step.image ?? makeUrl('content/researchkit/images/completion.png');

    return (
        <div className="completion-step">
            <div className="current-step instruction-step">
                <div className="step-content">
                    <div className="instruction-step-text">
                        {step.title && (
                            <div className="step-title" style={getTextStyles('title', surveyDefinition, step, true)}>
                                <SurveyMarkdown text={step.title} inline={true} />
                            </div>
                        )}
                        {step.text && (
                            <div className="step-text" style={getTextStyles('text', surveyDefinition, step, true)}>
                                <SurveyMarkdown text={step.text} />
                            </div>
                        )}
                        {step.detailText && (
                            <div className="step-text" style={getTextStyles('detailText', surveyDefinition, step, true)}>
                                <SurveyMarkdown text={step.detailText} />
                            </div>
                        )}
                    </div>
                    <div className="completion-indicator">
                        <img src={imageUrl} alt={step.imageAltText ?? ''} />
                    </div>
                </div>
            </div>
        </div>
    );
}
